import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { isAppReady } from '../../store/reducers';
import { auth } from '../../store/auth/auth.selectors';
import { filter, withLatestFrom, switchMap, map } from 'rxjs/operators';
import * as actions from '../../store/actions';

/**
 * Guards routes that should only be accessed by logged in users
 */
@Injectable()
export class AuthenticatedGuard  {
  private appReady: Observable<boolean>;
  private authenticated: Observable<boolean>;
  constructor(private store: Store<any>) {
    this.appReady = this.store.select(isAppReady);
    this.authenticated = this.store.select(auth.getLoggedIn);
  }

  public canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.appReady.pipe(
      filter((ready) => ready),
      withLatestFrom(this.authenticated),
      map(([ready, authenticated]) => {
        if (!authenticated) {
          this.store.dispatch(
            actions.RequireLogin({
              postLoginRoute: state.url,
            })
          );
          return false;
        }
        return true;
      })
    );
  }
}
